module.exports = __webpack_public_path__ + "17a053fc4ad75226693a3f92e34e1d37.svg";